import React from 'react';
import { useTranslation } from 'react-i18next';
import './About.css';

const About = () => {
  const { t } = useTranslation();

  const TechLogo = ({ name }) => {
    const logoMap = {
      'Laravel': '/logos/laravel.svg',
      'PHP': '/logos/php.svg',
      'Django': '/logos/django.svg',
      'Python': '/logos/python.svg',
      'React': '/logos/react.svg',
      'Vue.js': '/logos/vue.svg',
      'Tailwind CSS': '/logos/tailwind.svg',
      'JavaScript': '/logos/javascript.svg',
      'WordPress': '/logos/wordpress.svg',
      'Laravel Filament': '/logos/filament.svg',
      'Google Cloud': '/logos/google-cloud.svg',
      'Linux Servers': '/logos/linux.svg'
    };

    return logoMap[name] ? <img src={logoMap[name]} alt={name} className="tech-logo" /> : null;
  };

  const technologies = {
    backend: [
      { name: 'Laravel' },
      { name: 'PHP' },
      { name: 'Django' },
      { name: 'Python' }
    ],
    frontend: [
      { name: 'React' },
      { name: 'Vue.js' },
      { name: 'Tailwind CSS' },
      { name: 'JavaScript' }
    ],
    cms: [
      { name: 'WordPress' },
      { name: 'Laravel Filament' }
    ],
    cloud: [
      { name: 'Google Cloud' },
      { name: 'Linux Servers' }
    ]
  };

  return (
    <section className="about" id="about">
      <div className="container">
        <div className="about-header fade-in-up">
          <span className="eyebrow">~/stack</span>
          <h2>{t('about.title')}</h2>
          <p className="about-intro">{t('about.intro')}</p>
          <p className="about-description">{t('about.description')}</p>
        </div>

        <div className="tech-section fade-in-up delay-200">
          <div className="tech-category">
            <h3>{t('about.tech.backend')}</h3>
            <div className="tech-grid">
              {technologies.backend.map((tech, index) => (
                <div key={index} className="tech-item">
                  <TechLogo name={tech.name} />
                  <span className="tech-name">{tech.name}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="tech-category">
            <h3>{t('about.tech.frontend')}</h3>
            <div className="tech-grid">
              {technologies.frontend.map((tech, index) => (
                <div key={index} className="tech-item">
                  <TechLogo name={tech.name} />
                  <span className="tech-name">{tech.name}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="tech-category">
            <h3>{t('about.tech.cms')}</h3>
            <div className="tech-grid">
              {technologies.cms.map((tech, index) => (
                <div key={index} className="tech-item">
                  <TechLogo name={tech.name} />
                  <span className="tech-name">{tech.name}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="tech-category">
            <h3>{t('about.tech.cloud')}</h3>
            <div className="tech-grid">
              {technologies.cloud.map((tech, index) => (
                <div key={index} className="tech-item">
                  <TechLogo name={tech.name} />
                  <span className="tech-name">{tech.name}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;